import './CartFlyout.scss';
import Component from './CartFlyout.js';
export default Component;
